import React from 'react';
import { toast } from 'react-toastify';
import {
  AUTO_CLEAR_HOURS,
  removeDownload,
  scheduleClear,
  shouldOfferRemoval,
} from '../../../utils/offlineDownloadRemoval';
import db from '../../../db/db';
import './_RemoveDownloadPrompt.scss';

/**
 * SW2-2459 (PR 2) — "Project fully synced: remove the download now, or keep it and clear it
 * automatically in 24 hours." Shown once per download, after the user's own signature on the
 * first inspection line has gone through. Keeping is the default: closing the prompt keeps it.
 */
export async function offerDownloadRemoval(projectId: number) {
  if (!(await shouldOfferRemoval(projectId))) return;

  const project = await db.projects.get(projectId);

  await scheduleClear(projectId);

  const toastId = `remove-download-${projectId}`;
  const removeNow = async () => {
    toast.dismiss(toastId);

    try {
      if (await removeDownload(projectId)) {
        toast.success(`${project?.name || 'Project'} removed from this device.`);
      } else {
        toast.info('New offline work was added, so the download was kept. It will sync automatically.');
      }
    } catch (e) {
      const err: any = e;
      // eslint-disable-next-line no-console

      console.error(`Removing project ${projectId} from this device failed`, err);
      toast.error(
        `Couldn't remove ${project?.name || 'the project'} from this device: ${
          err?.message || err
        }. It will be cleared automatically in ${AUTO_CLEAR_HOURS} hours.`,
      );
    }
  };

  toast.success(
    <div className='remove-download-prompt'>
      <p>
        <strong>{project?.name || 'Project'} is fully synced.</strong> Remove the download from this
        device now, or keep it — it will be cleared automatically in {AUTO_CLEAR_HOURS} hours.
      </p>
      <div className='remove-download-prompt__actions'>
        <button type='button' className='button-primary' onClick={removeNow}>
          Remove now
        </button>
        <button type='button' className='button-secondary' onClick={() => toast.dismiss(toastId)}>
          Keep {AUTO_CLEAR_HOURS} hours
        </button>
      </div>
    </div>,
    { toastId, autoClose: false, closeOnClick: false },
  );
}
